<template>
    <div class="dictionary" v-if="permisShow('小区查看')">
        <div class="dict_search">
            <div class="dict_search_left">
                <ul class="dict_search_select">
                    <li class="dict_select_item">
                        <span class="year">区域：</span>
                        <el-select v-model="params.areaId" placeholder="不限" @visible-change="getRegionList" @change="params['page.pageNumber']=0,pageNumber=0,params.tradeAreaId='',getHouseAreaList()">
                            <el-option v-for="(item,index) in this.regionList" :key="index" :label="item.name" :value="item.areaId">
                            </el-option>
                        </el-select>
                    </li>
                    <li class="dict_select_item">
                        <span class="year">商圈：</span>
                        <el-select v-model="params.tradeAreaId" placeholder="不限" @visible-change="getTradeAreaList" @change="params['page.pageNumber']=0,pageNumber=0,getHouseAreaList()">
                            <el-option v-for="(item,index) in this.tradeAreaList" :key="index" :label="item.tradeAreaName" :value="item.tradeAreaId"></el-option>
                        </el-select>
                    </li>
                    <li class="dict_select_item">
                        <!-- <div class="search_box"> -->
                        <span class="year">小区名称：</span>
                        <el-input v-model="params.areaName"></el-input>
                        <!-- <el-autocomplete popper-class="my-autocomplete" v-model="params.areaName"
                :fetch-suggestions="querySearchAsync" placeholder="请输入您要查询小区名称" @select="handleSelect">
                <template slot-scope="{ item }">
                  <div class="name" @select="handleSelect">{{ item.name }}</div>
                </template>
              </el-autocomplete> -->
                        <!-- </div> -->
                    </li>
                    <li class="dict_select_item">
                        <span class="year">状态：</span>
                        <el-select v-model="params.whetherOpen" placeholder="不限" @visible-change="getWhetherOpen" @change="params['page.pageNumber']=0,pageNumber=0,getHouseAreaList()">
                            <el-option v-for="(item,index) in whetherOpenList" :key="index" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </li>
                    <li class="dict_select_item">
                        <button class="add_hosue_btn" @click="params['page.pageNumber']=0,pageNumber=0,getHouseAreaList()">搜索</button>
                    </li>
                </ul>
            </div>
            <div class="dict_search_right">
                <i class="iconfont iconmoren01" :class="tabindex===0?'iconactive':''" @click="tabindex=0"></i>
                <i class="iconfont icontupian" :class="tabindex===1?'iconactive':''" @click="tabindex=1"></i>
                <button class="add_hosue_btn" v-if="permisShow('添加小区')" @click="goAddCommunity()">添加小区</button>
            </div>

        </div>
        <div class="space">
            <span class="statusColor" v-if="stateBtn">状态禁止之后不能录入该楼盘的房源</span>
        </div>
        <div class="builid_content" ref="build_wrap">
            <ul class="build_wrap" v-if="tabindex===1">
                <li class="build_item" ref='build_item' v-for="(item,index) in housingList" :key="index" @click="goDetails(item.residentialAreaId)">
                    <div class="build_img" v-if="item.exteriorPicture">
                        <img :src="'http://'+item.exteriorPicture[0]" />
                    </div>
                    <div class="build_img" v-else>
                        <img src="../../assets/images/nobuild.png" />
                    </div>
                    <p class="build_info">{{item.name}}</p>
                    <p class="build_info_blue">{{item.avgPrice + '元'}}</p>
                    <p class="build_position">{{item.areaName + '/'}}{{item.tradeAreaName}}</p>
                </li>
            </ul>

            <el-table :data="housingList" border style="width: 100%" @row-dblclick="goDetails1" v-if="tabindex===0">
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="areaName" label="区域"></el-table-column>
                <el-table-column prop="tradeAreaName" label="商圈"></el-table-column>
                <el-table-column prop="address" label="地址"></el-table-column>
                <el-table-column prop="avgPrice" label="均价"></el-table-column>
                <el-table-column prop="totalTungs" label="总栋数"></el-table-column>
                <el-table-column prop="setNumber" label="总户数"></el-table-column>
                <el-table-column prop="saleNumber" label="在售户数"></el-table-column>
                <el-table-column prop="rentingNumber" label="在租户数"></el-table-column>
                <el-table-column prop="rentingNumber">
                    <template slot="header" slot-scope="scope">
                        <div style="display:flex;align-items:center;justify-content:center;">
                            <span>状态</span>
                            <i class="iconfont icon-tixing" style="color:#ff8000;font-size:20px;" @mouseenter="stateBtn=true" @mouseleave="stateBtn=false"></i>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div @click.stop="switchRuleChange(scope.row)">
                            <el-switch style="display: block" active-color="#5e75e6" inactive-color="#e6e6e6" v-model="scope.row.whetherOpen" :disabled="!permisShow('状态编辑')">
                            </el-switch>
                        </div>

                    </template>
                </el-table-column>
            </el-table>

        </div>
        <div class="footer_page">
            <p class="data_number">
                共
                <span>{{total}}</span>条
            </p>
            <el-pagination background :current-page.sync="pageNumber" layout=" prev, pager, next" :total="total" :page-size="PageSize" :page-sizes="[5, 10, 20, 30]" @current-change="handleCurrentChange($event,params)"></el-pagination>
        </div>
    </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import { domPageSize } from "../../vue/util/tool";
import {
    communitynameQuery,
    communityAdd,
    communityDelete,
    communityQuery,
    communityUpdate,
    areaQuery,
    tradeareaQuery,
    updateWhetherOpen,
} from "@/api/manageCenter";
import { mapGetters } from "vuex";
import { timeoutPromise, dosome } from "../../vue/test/Promise";
import { Form } from "element-ui";
export default {
    // name: "楼盘字典",
    name: "/CommunityList",
    data() {
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            permisList,
            urlData: "http://file.gfwlkj.cn:8877/",
            tabindex: 0,
            stateBtn: false,
            secrchContent: "",
            tradeAreaList: [],
            whetherOpenList: [],
            housingList: [],
            regionList: [],
            total: 0,
            PageSize: 0,
            pageNumber: 0,
            params: {
                "page.pageNumber": 0,
                "page.pageSize": 0,
                areaId: "",
                tradeAreaId: "",
                areaName: "",
                avgPrice: "",
                whetherOpen: "",
            },
        };
    },
    mounted() {
        // throw Error('测试')
        let width = this.$refs.build_wrap.offsetWidth;
        let height = this.$refs.build_wrap.offsetHeight;
        let itemwidth = 200;
        let itemheight = 240;
        this.params["page.pageSize"] = domPageSize(
            width,
            height,
            itemwidth,
            itemheight
        );

        this.PageSize = this.params["page.pageSize"];
        this.params["page.pageNumber"] = 0;

        console.log(1234, this.params);
        this.getHouseAreaList(this.params);
        // this.timeouttest();
        // this.dosome1()
    },
    activated() {
        let delStatus = sessionStorage.getItem("communitydelet");
        if (delStatus === "del") {
            // alert(12)
            let width = this.$refs.build_wrap.offsetWidth;
            let height = this.$refs.build_wrap.offsetHeight;
            let itemwidth = 200;
            let itemheight = 240;
            this.params["page.pageSize"] = domPageSize(
                width,
                height,
                itemwidth,
                itemheight
            );

            this.PageSize = this.params["page.pageSize"];
            this.getHouseAreaList(this.params);
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        // 可以访问组件实例 `this`
        sessionStorage.removeItem("communitydelet");
        next();
    },
    computed: {
        // ...mapGetters(["regionList", "storeList"])
    },
    methods: {
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        //楼盘字典是否启用
        switchRuleChange(val) {
            if (this.permisShow("状态编辑")) {
                if (!val.whetherOpen) {
                    this.$confirm("当楼盘禁掉之后，不能再录入该楼盘房源，请谨慎操作！", "确定要把楼盘禁掉吗?", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                        center: true,
                    })
                        .then(() => {
                            this.updateWhetherOpenState(val);
                        })
                        .catch(() => {
                            val.whetherOpen = true;
                        });
                } else {
                    this.updateWhetherOpenState(val);
                }
            }
        },
        //修改楼盘状态
        updateWhetherOpenState(val) {
            let params = {
                whetherOpen: val.whetherOpen,
                residentialAreaId: val.residentialAreaId,
            };
            this.$post(updateWhetherOpen, params).then((res) => {
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.getHouseAreaList();
                }
            });
        },
        timeouttest() {
            timeoutPromise(100).then((res) => {
                console.log(123213213, res);
            });
        },

        dosome1() { },

        getRegionList(val) {
            // 查询区域列表
            if (val) {
                this.$post(areaQuery).then((res) => {
                    if (res.success) {
                        this.regionList = res.data;
                        var text = {
                            name: "不限",
                            storeId: null,
                        };
                        this.regionList.unshift(text);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                });
            }
        },
        getWhetherOpen(val) {
            if (val) {
                this.whetherOpenList = [
                    { name: "不限", value: null },
                    { name: "启用", value: 1 },
                    { name: "禁用", value: 0 },
                ];
            }
        },
        getTradeAreaList(val) {
            // 商圈列表
            if (val) {
                let params = {
                    areaId: this.params.areaId,
                };

                this.$post(tradeareaQuery, params).then((res) => {
                    if (res.success) {
                        this.tradeAreaList = res.data;
                        var text = {
                            tradeAreaName: "不限",
                            areaId: null,
                            tradeAreaId: null,
                        };
                        this.tradeAreaList.unshift(text);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                });
                this.getHouseAreaList(this.params);
            }
        },
        getAreaIdList() {
            this.getHouseAreaList(this.params);
        },
        inpSearchStart() {
            this.getHouseAreaList(this.params);
        },
        goAddCommunity() {
            this.$router.push({ path: "/CommunityAdd" });
        },
        goDetails(id) {
            sessionStorage.setItem("residentialAreaId", id);
            this.$router.push({ path: "/CommunityDetail" });
        },
        goDetails1(row, column, event) {
            sessionStorage.setItem("residentialAreaId", row.residentialAreaId);
            this.$router.push({ path: "/CommunityDetail" });
        },
        querySearchAsync(queryString, cb) {
            // 查询小区

            let params = {
                name: queryString,
                "page.pageNumber": 0,
                "page.pageSize": this.PageSize,
            };
            this.$post(communitynameQuery, params).then((res) => {
                if (res.success) {
                    this.housingData = res.data;
                    let restaurants = this.housingData;
                    this.getHouseAreaList(this.params);
                    cb(restaurants);
                } else {
                }
            });
        },

        createStateFilter(queryString) {
            // 过滤小区关键字
            return (state) => {
                return (
                    state.value
                        .toLowerCase()
                        .indexOf(queryString.toLowerCase()) === 0
                );
            };
        },

        handleSelect(item) {
            //  //cosole.log(111, item);
            this.params.areaName = item.name;
            this.params["page.pageNumber"] = 0;
            this.getHouseAreaList(this.params);
        },
        // 查询小区列表
        getHouseAreaList(data) {
            // console.log(this.params);
            let params = this.params;
            this.$post(communityQuery, params).then((res) => {
                if (res.success) {
                    this.housingList = res.data;
                    this.total = res.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            });
        },
        handleCurrentChange(val, info) {
            //cosole.log(`${val}`);
            //cosole.log(info);
            this.params["page.pageNumber"] =
                `${val}` === 1 ? 0 : `${val}` * this.PageSize - this.PageSize;
            this.getHouseAreaList(info);
        },
        handleSizeChange(val) {
            this.PageSize = val;
            this.params["page.pageSize"] = val;
            this.getHouseAreaList();
        },
    },
};
</script>
<style type="text/css" lang="less" >
.el-message-box {
    .el-message-box__btns {
        .el-button--primary {
            background-color: #5e75e6;
            border-color: #5e75e6;
        }
    }
}
.dictionary {
    height: 100%;
    background: white;
    display: flex;
    flex-direction: column;
    .el-switch.is-checked .el-switch__core:after {
        background: #fff;
    }
    .dict_search {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 10px;
        padding-right: 80px;

        .dict_search_left {
            display: flex;
            align-items: center;

            .dict_search_select {
                display: flex;
                .dict_select_item {
                    min-width: 130px;
                    margin-left: 20px;
                    height: 30px;
                    display: flex;
                    align-items: center;
                    font-size: 12px;

                    .year {
                        padding: 4px 8px;
                        min-width: 30px;
                        color: #666;
                    }
                    .el-select {
                        width: 80px;
                        .el-input--suffix {
                            width: 80px;
                        }
                        .el-input__inner {
                            border: none;
                            padding: 0px;
                            padding-left: 10px;
                            height: 30px;
                            // background: #f5f5f5;
                            border: 1px solid #dbdbdb;
                            border-radius: 3px;
                            width: 80px;
                        }
                        .el-input__icon {
                            line-height: 30px !important;
                        }

                        .el-input__suffix {
                            right: 0;
                        }
                    }

                    .el-input {
                        width: 200px;
                        .el-input__inner {
                            border: none;
                            padding: 0px;
                            padding-left: 10px;
                            height: 30px;
                            // background: #f5f5f5;
                            border: 1px solid #dbdbdb;
                            border-radius: 3px;
                            // width: 0px;
                        }
                    }

                    &.item_years {
                        display: flex;
                        align-items: center;

                        .el-input {
                            width: 80px;
                            .el-input__inner {
                                padding: 0 5px;
                                border: none;
                                text-align: center;
                            }
                        }
                    }

                    &.item_price {
                        border-right: none;
                    }
                }
            }
            .search_box {
                // height: 30px;
                .el-input__inner {
                    height: 30px;
                    line-height: 30px;
                    border: 1px solid #dbdbdb;
                }
                .el-input-group__append,
                .el-input-group__prepend {
                    padding: 0 10px;
                    .icon-icon_sousuo {
                        font-size: 20px;
                        color: white;
                    }
                }
            }
        }
        .dict_search_right {
            display: flex;
            align-items: center;
            .iconmoren01 {
                font-size: 28px;
                padding-right: 30px;
            }
            .icontupian {
                font-size: 28px;
                padding-right: 50px;
            }
            .iconactive {
                color: #ff904d;
            }
        }
        .add_hosue_btn {
            width: 140px;
            height: 30px;
            background: #5e75e6;
            border-radius: 4px;
            border: none;
            outline: none;
            font-size: 14px;
            color: #ffffff;
        }
    }

    .space {
        height: 24px;
        line-height: 24px;
        background: #f5f5f5;
        width: 100%;
        text-align: right;
        .statusColor {
            color: #ff8000;
            font-size: 14px;
            margin-right: 10px;
        }
    }

    .builid_content {
        flex: 1;
        overflow: hidden;
        overflow-y: scroll;
        .build_wrap {
            display: flex;
            flex-wrap: wrap;

            .build_item {
                width: 180px;
                margin-left: 20px;
                margin-top: 20px;
                margin-bottom: 20px;
                .build_img {
                    width: 100%;
                    height: 130px;
                    border-radius: 4px;
                    overflow: hidden;
                    border: 1px solid #ccc;
                    > img {
                        border: none;
                        width: 100%;
                        height: 100%;
                    }
                }

                .build_title {
                    font-size: 16px;
                    color: #333333;
                    margin-top: 10px;
                    font-weight: 600;
                    padding: 0 8px;
                }

                .build_position,
                .build_info {
                    font-size: 14px;
                    color: #333333;
                    margin-top: 8px;
                    padding: 0 8px;
                }
                .build_position,
                .build_info_blue {
                    font-size: 14px;
                    color: #333333;
                    margin-top: 8px;
                    padding: 0 8px;
                    color: #5e75e6;
                }
                .build_position {
                    color: #999999;
                }
            }
        }
    }
    .footer_page {
        position: relative;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 30px;
        background: #f5f5f5;
        padding: 10px 30px;
        .data_number {
            font-size: 12px;
            margin-right: 10px;
        }
        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #5e75e6;
        }

        .el-pagination.is-background .btn-next,
        .el-pagination.is-background .btn-prev,
        .el-pagination.is-background .el-pager li {
            border: 1px solid #ccc;
            background: white;
        }

        // .el-icon-arrow-left:before {
        //   content: "上一页";
        //   padding: 0 20px;
        //   color: #cccccc;
        //   font-size: 12px;
        // }

        // .el-icon-arrow-right:before {
        //   content: "下一页";
        //   padding: 0 20px;
        //   color: #cccccc;
        //   font-size: 12px;
        // }
    }
}
</style>
